// Modules
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { AUTH_SERVICES } from 'constants';
import { Table, SortableTH } from 'components/content-containers/tables';
import CompanyNickname from 'components/models/company/company-nickname';
import Person from 'services/data/person';
import Tooltip from 'components/widgets/overlays/tooltip';


// Component
function PeopleTable({ people = [] }) {
  return (
    <Table>
      <thead>
        <tr>
          <SortableTH sortField="firstName">Name</SortableTH>
          <SortableTH sortField="company.name">Company</SortableTH>
          <SortableTH sortField="role">Security Role</SortableTH>
          <th>Tags</th>
          { _.map(AUTH_SERVICES, service =>
            <th className="collapse-width grid-cell" key={service}>
              <Tooltip title={_.startCase(service)}>
                {_(service).words().map(_.head).map(_.toUpper).join('')}
              </Tooltip>
            </th>
          ) }
        </tr>
      </thead>
      <tbody>
        { _.map(people, (person) => {
          const roles = person.externalAppAuthRoles;

          return (
            <tr key={person.id}>
              <td><Link to={`/admin/users/${person.id}`}>{Person.fullName(person)}</Link></td>
              <td><CompanyNickname company={person.company} /></td>
              <td>{person.role}</td>
              <td className="tag-cell">
                { _.map(person.tags, (tag, index) =>
                  <Tooltip key={index} className="tag" elementType="span" title={tag}>
                    { _.size(tag) > 2 && _(tag).words().map(_.head).join('') }
                    { _.size(tag) <= 2 && tag }
                  </Tooltip>
                ) }
              </td>
              { _.map(AUTH_SERVICES, service =>
                <td className="grid-cell collapse-width" key={service}>
                  <Tooltip title={`${_.startCase(service)}: ${_.join(_.get(roles, service), ', ')}`}>
                    {_(_.get(roles, service)).map(role => _(role).words().map(_.head).join('')).join(', ')}
                  </Tooltip>
                </td>
              ) }
            </tr>
          );
        }) }
      </tbody>
    </Table>
  );
}

// Prop types
PeopleTable.propTypes = {
  people: PropTypes.array
};

export default PeopleTable;
